// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "theme-components-Filter" + "." + "34f109bd" + ".chunk.css";
};